<div class="container mt-4">
  <h2 class="mb-4">GESTION DES PAIEMENTS</h2>

  <div class="bg-light p-3 mb-4 rounded">
    <div class="row align-items-center">
      <div class="col-md-8">
        <div class="d-flex align-items-center flex-wrap invoice-action-group">
          <div class="btn-group me-2">
            <button type="button" class="btn btn-outline-secondary" (click)="openCalendarForm()">
              <i class="fa fa-calendar"></i> Calendrier
            </button>
            <button type="button" class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
              data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <span class="visually-hidden">Periode</span>
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="onChangePeriode('today')">Aujourd'hui</a>
              <a class="dropdown-item" (click)="onChangePeriode('week')">Cette Semaine</a>
              <a class="dropdown-item" (click)="onChangePeriode('lastWeek')">Semaine Dernière</a>
              <a class="dropdown-item" (click)="onChangePeriode('month')">Ce mois ci</a>
            </div>
          </div>

          <div class="btn-group me-2" role="group">
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="onChangeSortBy('date')" title="Trier par Date">
              <i class="fa" [ngClass]="getSortIcon('date')"></i> Date
            </button>
            <button type="button" class="btn btn-sm btn-outline-primary" (click)="onChangeSortBy('invoiceNumber')" title="Trier par N° Facture">
              <i class="fa" [ngClass]="getSortIcon('invoiceNumber')"></i> N° Facture
            </button>
          </div>

          @if (isSuperAdmin()) {
            <button type="button"
              class="btn btn-sm btn-danger ms-2"
              (click)="openResetInvoicePopup()"
              title="Réinitialiser les numéros de facture"
              >
              <i class="fa fa-refresh"></i> Réinitialiser Factures
            </button>
          }
        </div>
      </div>
      <div class="col-md-4 text-end">
        <h5 class="mb-0 period-text">{{periode}}</h5>
      </div>
    </div>
  </div>

  <!-- Filtrage par mode de paiement -->
  <div class="bg-white p-3 mb-3 rounded border">
    <div class="row align-items-center">
      <div class="col-md-12">
        <label class="fw-bold me-3">Filtrer par mode de paiement :</label>
        <div class="btn-group btn-group-toggle" role="group">
          <button type="button"
            class="btn"
            [ngClass]="isFilterActive(null) ? 'btn-primary' : 'btn-outline-primary'"
            (click)="onFilterByPaymentMethod(null)">
            <i class="fa fa-list"></i> Tous
          </button>
          <button type="button"
            class="btn"
            [ngClass]="isFilterActive('ESPECE') ? 'btn-success' : 'btn-outline-success'"
            (click)="onFilterByPaymentMethod('ESPECE')">
            <i class="fa fa-money"></i> Espèces
          </button>
          <button type="button"
            class="btn"
            [ngClass]="isFilterActive('CB') ? 'btn-info' : 'btn-outline-info'"
            (click)="onFilterByPaymentMethod('CB')">
            <i class="fa fa-credit-card"></i> CB
          </button>
          <button type="button"
            class="btn"
            [ngClass]="isFilterActive('VIREMENT') ? 'btn-warning' : 'btn-outline-warning'"
            (click)="onFilterByPaymentMethod('VIREMENT')">
            <i class="fa fa-exchange"></i> Virement
          </button>
          <button type="button"
            class="btn"
            [ngClass]="isFilterActive('CHEQUE') ? 'btn-secondary' : 'btn-outline-secondary'"
            (click)="onFilterByPaymentMethod('CHEQUE')">
            <i class="fa fa-file-text-o"></i> Chèque
          </button>
        </div>
      </div>
    </div>
  </div>

  @if (messageError) {
    <div class="alert alert-danger" role="alert">
      {{messageError}}
    </div>
  }

  <app-payment-list
    [iShowPayments]="true"
    [iPagePayment]="pagePayment"
    [iPayments]="payments"
    [iTotalPaymentDetails]="totalPaymentDetails"
    [iShowStudent]="true"
    [iIsStudent]="false"
    [iNavMobile]="false"
    [iShowUpdateBtn]="false"
    [iShowRefundButton]="false"
    (iPageNumber)="onChangePaymentPage($event)"
    (oPaymentToUpdate)="onPaymentToUpdate($event)"
    (oPaymentDisabled)="onPaymentDisabled($event)"
    (oPaymentRefund)="onPaymentRefund($event)"
    (oOpenRefundForm)="onOpenRefundForm()">
  </app-payment-list>
</div>

<!-- Modal Calendrier -->
<div class="modal fade" id="calendarModal" tabindex="-1" role="dialog" aria-labelledby="calendarLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="calendarLabel">
          Choisir la période
        </h3>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form [formGroup]="calendarForm" #f="ngForm" name="calendarForm" (ngSubmit)="f.form.valid" novalidate>
        <div class="modal-body">
          <div class="form-row">
            <div class="col-md-6">
              <label for="startDate" class="col-form-label">DATE DE DÉBUT</label>
              <input id="startDate" type="date" class="form-control"
                name="startDate" formControlName="startDate" required>
            </div>
            <div class="col-md-6">
              <label for="endDate" class="col-form-label">DATE DE FIN</label>
              <input id="endDate" type="date" class="form-control"
                name="endDate" formControlName="endDate" required>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">ANNULER</button>
          <button type="button" class="btn btn-primary" (click)="isSubmited(f.form)">VALIDER</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Modal Mise à jour Paiement -->
<app-payment-update-form
  [iPayment]="paymentToUpdate"
  [iPaymentMethods]="paymentMethods"
  (oPaymentUpdated)="closeUpdatePaymentPopup()">
</app-payment-update-form>

<!-- Modal Suppression Paiement -->
<div class="modal fade" [class.show]="showDisabledPaymentPopup" [style.display]="showDisabledPaymentPopup ? 'block' : 'none'"
  tabindex="-1" role="dialog" aria-labelledby="disablePaymentLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="disablePaymentLabel">Confirmer la suppression</h5>
        <button type="button" class="close" (click)="closeDisabledPaymentPopup()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        Êtes-vous sûr de vouloir supprimer ce paiement ?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeDisabledPaymentPopup()">Annuler</button>
        <button type="button" class="btn btn-danger" (click)="confirmDisablePayment()">Supprimer</button>
      </div>
    </div>
  </div>
</div>
@if (showDisabledPaymentPopup) {
  <div class="modal-backdrop fade" [class.show]="showDisabledPaymentPopup"></div>
}

<!-- Modal Réinitialisation des numéros de facture -->
<div class="modal fade" [class.show]="showResetInvoicePopup" [style.display]="showResetInvoicePopup ? 'block' : 'none'"
  tabindex="-1" role="dialog" aria-labelledby="resetInvoiceLabel">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="resetInvoiceLabel">
          <i class="fa fa-refresh"></i> Réinitialiser les numéros de facture
        </h5>
        <button type="button" class="close" (click)="closeResetInvoicePopup()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label for="resetInvoiceYear">Année à renuméroter :</label>
          <select id="resetInvoiceYear"
            class="form-control"
            [ngModel]="resetInvoiceYear"
            (ngModelChange)="onResetYearChange($event)">
            <option [ngValue]="null">Toutes les années</option>
            @for (year of invoiceYears; track year) {
              <option [ngValue]="year">{{year}}</option>
            }
          </select>
        </div>

        <div class="alert alert-warning mb-0">
          <i class="fa fa-exclamation-triangle"></i>
          Cette action renumérote les paiements actifs dans l'ordre chronologique et resynchronise le compteur de factures.
        </div>

        @if (resetInvoiceMessage) {
          <div
            class="alert mt-3 mb-0"
            [ngClass]="resetInvoiceSuccess ? 'alert-success' : 'alert-danger'">
            {{resetInvoiceMessage}}
          </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeResetInvoicePopup()">Annuler</button>
        <button type="button"
          class="btn btn-danger"
          (click)="confirmResetInvoiceNumbers()"
          [disabled]="resetInvoiceLoading || (resetInvoiceMessage && resetInvoiceSuccess)">
          <i class="fa" [ngClass]="resetInvoiceLoading ? 'fa-spinner fa-spin' : 'fa-refresh'"></i> Réinitialiser
        </button>
      </div>
    </div>
  </div>
</div>
@if (showResetInvoicePopup) {
  <div class="modal-backdrop fade" [class.show]="showResetInvoicePopup"></div>
}
